import { useState } from 'react'
import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { ActionSelect } from '../../../Action'

import { useNewsboardPostHeaderItemActions } from './NewsboardPostHeader.hooks'
import { NewsboardPostHeaderContent } from './NewsboardPostHeaderContent'
import { Skeleton } from './Skeleton'

import * as styles from './NewsboardPostHeader.module.css'

function NewsboardPostHeader({
  data = EMPTY_OBJECT,
  loading,
  onReload,
  ...restProps
}) {
  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
  }

  const { actions, handleClickNewsboardPostHeaderItemAction } =
    useNewsboardPostHeaderItemActions({
      data,
      onCloseModal: handleCloseModal,
      onReload,
      onSetModal: setModal,
    })

  const headerClassName = classNames(styles.NewsboardPostHeader, {
    [styles.skeleton]: loading,
  })

  return (
    <div className={headerClassName}>
      {loading ? (
        <Skeleton />
      ) : (
        <>
          <NewsboardPostHeaderContent
            {...restProps}
            data={data}
            onReload={onReload}
          />
          {actions.length > 0 ? (
            <ActionSelect
              actions={actions}
              onClickAction={handleClickNewsboardPostHeaderItemAction}
            />
          ) : null}
        </>
      )}
      {modal}
    </div>
  )
}

export default NewsboardPostHeader
